'use client';

import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { useI18n } from '#/i18n/hooks/useI18n';
import { useSearchFacetsInternship } from '#/modules/search/constants/useSearchFacetsInternship';
import {
  useSearchFiltersByName,
  useSearchQuery,
} from '#/modules/search/contexts/SearchContext';
import { searchShouldShowSortOptions } from '#/modules/search/helpers/searchShouldShowSortOptions';
import { SearchPage } from '#/modules/search/pages/Search/SearchPage';
import { trackPageView } from '#/utils/analytics/track/trackPageView';

export function SearchInternshipsPage() {
  const { i18n } = useI18n();

  const query = useSearchQuery();
  const filters = useSearchFiltersByName();

  const location = useLocation();
  useEffect(() => {
    trackPageView('Search Internships');
  }, [location.key]);

  const { internshipSearchFacets } = useSearchFacetsInternship(i18n);

  return (
    <SearchPage
      searchFacets={internshipSearchFacets}
      searchType="INTERNSHIP"
      showSortOptions={searchShouldShowSortOptions({
        searchType: 'INTERNSHIP',
        query,
        filters,
      })}
    />
  );
}
